<div class="figma-chrome-frame-page company-list-page" [ngClass]="{'blur-background': displayStyle === 'block' || displaySubscriptionModal === 'block' || displayEnterModal === 'block'}">
  <div class="figma-chrome-frame-shell company-list-shell">
    <header class="company-list-header">
      <div class="company-list-header-bar">
        <img
          class="company-list-logo"
          src="assets/images/a-square-navbar-brand.png"
          alt="A Square ERP Solutions"
          width="117"
          height="24"
        />
        <div class="company-list-header-actions">
          <button type="button" class="company-list-header-btn company-list-header-btn--payment" (click)="redirectToPayment()">
            <span class="company-list-header-btn-icon" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.75 14.25C4.64331 14.25 3.58996 14.25 2.83329 13.7444C2.50572 13.5255 2.22447 13.2443 2.00559 12.9167C1.5 12.16 1.5 11.1067 1.5 9C1.5 6.89331 1.5 5.83996 2.00559 5.08329C2.22447 4.75572 2.50572 4.47447 2.83329 4.25559C3.58996 3.75 4.64331 3.75 6.75 3.75L11.25 3.75C13.3567 3.75 14.41 3.75 15.1667 4.25559C15.4943 4.47447 15.7755 4.75572 15.9944 5.08329C16.5 5.83996 16.5 6.89331 16.5 9C16.5 11.1067 16.5 12.16 15.9944 12.9167C15.7755 13.2443 15.4943 13.5255 15.1667 13.7444C14.41 14.25 13.3567 14.25 11.25 14.25H6.75Z" stroke="white" stroke-width="1.3"/>
                <path d="M6.75 6.75C5.50736 6.75 4.5 7.75736 4.5 9C4.5 10.2426 5.50736 11.25 6.75 11.25" stroke="white" stroke-width="1.3"/>
                <path d="M11.25 6.75C12.4926 6.75 13.5 7.75736 13.5 9C13.5 10.2426 12.4926 11.25 11.25 11.25" stroke="white" stroke-width="1.3"/>
                <path d="M6.75 3.75V13.875" stroke="white" stroke-width="1.3" stroke-linecap="round"/>
                <path d="M11.25 3.75V13.875" stroke="white" stroke-width="1.3" stroke-linecap="round"/>
              </svg>
            </span>
            <span class="company-list-header-btn-label">Payment</span>
          </button>
          <button type="button" class="company-list-logout-btn" (click)="logout()">
            <span class="company-list-logout-icon" aria-hidden="true">
              <svg
                class="company-list-logout-icon-svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_company_list_logout)">
                  <path
                    d="M11.248 5.25C11.239 3.61873 11.1666 2.7353 10.5903 2.15901C9.93133 1.5 8.87067 1.5 6.74935 1.5L5.99935 1.5C3.87803 1.5 2.81737 1.5 2.15836 2.15901C1.49935 2.81802 1.49935 3.87868 1.49935 6L1.49935 12C1.49935 14.1213 1.49935 15.182 2.15836 15.841C2.81737 16.5 3.87803 16.5 5.99935 16.5H6.74935C8.87067 16.5 9.93133 16.5 10.5903 15.841C11.1666 15.2647 11.239 14.3813 11.248 12.75"
                    stroke="currentColor"
                    stroke-width="1.3"
                    stroke-linecap="round"
                  />
                  <path
                    d="M6.75 9L16.5 9M13.875 11.25L16.5 9L13.875 6.75"
                    stroke="currentColor"
                    stroke-width="1.3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_company_list_logout">
                    <rect width="18" height="18" rx="5" transform="matrix(-1 0 0 1 18 0)" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <span class="company-list-logout-label">Logout</span>
          </button>
          <button type="button" class="company-list-user" (click)="openSubscriptionDetailsModal()">
            <img class="company-list-user-avatar" src="assets/images/avatar.jpg" alt="" />
            <span class="company-list-user-info">
              <span class="company-list-user-name">{{ displayUserName }}</span>
              <span class="company-list-user-role">Super Admin</span>
            </span>
          </button>
        </div>
      </div>
    </header>

    <div class="company-list-body">
      <div class="company-list-panel">
        <div class="company-list-toolbar-wrap">
          <div class="company-list-toolbar">
            <div class="company-list-toolbar-start">
              <form class="company-list-search" [formGroup]="searchGroup" autocomplete="off" noFocusNav>
                <span class="company-list-search-field">
                  <span class="company-list-search-icon" aria-hidden="true"></span>
                  <input
                    type="text"
                    class="company-list-search-input"
                    placeholder="search company"
                    formControlName="search"
                    (input)="applyFilter($event)"
                    aria-label="Search company"
                  />
                </span>
              </form>
            </div>

            <button type="button" class="company-list-add-btn" (click)="redirectToAddCompany()">
              <i class="fas fa-plus" aria-hidden="true"></i>
              <span>Add Company</span>
            </button>
          </div>
        </div>

        <div class="company-list-content">
          <div class="company-list-cards-scroll">
            <div class="company-list-cards-page">
              @if (filteredCompanies.length) {
                  <div class="company-list-cards-sheet">
                    <div class="company-list-cards figma-chrome-frame-card-grid">
                      @for (element of filteredCompanies; track element.companyId) {
                      <article
                        class="company-card"
                        role="button"
                        tabindex="0"
                        [attr.aria-label]="'Enter ' + element.name"
                        (click)="onCompanyCardActivate(element, $event)"
                        (keydown.enter)="onCompanyCardActivate(element, $event)"
                        (keydown.space)="onCompanyCardActivate(element, $event)"
                      >
                        <div class="company-card-inner">
                          <div class="company-card-main">
                            <div class="company-card-meta">
                              <span class="company-card-code">{{ formatCompanyCode(element) }}</span>
                              @if (getLastSessionLabel(element); as lastSession) {
                                <span class="company-card-session">{{ lastSession }}</span>
                              }
                            </div>

                            <div class="company-card-title-block">
                              <h4 class="company-card-name">{{ element.name }}</h4>
                              <p class="company-card-location">{{ getCompanyLocation(element) }}</p>
                            </div>

                            <div class="company-card-stats">
                              <div class="company-card-stat">
                                <div class="company-card-stat-row">
                                  <span class="company-card-stat-label">Total Users</span>
                                  <span class="company-card-stat-badge">{{ getStatValue(element, 'totalUsers') }}</span>
                                </div>
                              </div>
                              <div class="company-card-stat">
                                <div class="company-card-stat-row">
                                  <span class="company-card-stat-label">Active Users</span>
                                  <span class="company-card-stat-badge">{{ getStatValue(element, 'activeUsers') }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="company-card-footer">
                          <button
                            type="button"
                            class="company-card-enter-btn"
                            tabindex="-1"
                            aria-hidden="true"
                          >
                            <svg
                              class="company-card-enter-icon"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                            >
                              <path
                                d="M5 12H19M12 19L19 12L12 5"
                                stroke-width="1.3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <span class="company-card-enter-label">Enter</span>
                          </button>

                          <div class="company-card-actions" (click)="$event.stopPropagation()">
                            <button
                              type="button"
                              class="company-card-icon-btn company-card-icon-btn--settings company-card-icon-btn--swap"
                              aria-label="Company settings"
                            >
                              <svg
                                class="company-card-icon-btn__icon company-card-icon-btn__icon--default company-card-settings-icon--linear"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                              >
                                <circle cx="12" cy="12" r="2.5" stroke-width="1.3" />
                                <path
                                  d="M13.4715 3.79349C13.1653 3.66663 12.777 3.66663 12.0004 3.66663C11.2238 3.66663 10.8355 3.66663 10.5293 3.79349C10.1209 3.96265 9.79642 4.28711 9.62726 4.69549C9.55005 4.88191 9.51983 5.09871 9.508 5.41495C9.49062 5.87969 9.25229 6.30987 8.84953 6.5424C8.44677 6.77493 7.95506 6.76624 7.5439 6.54892C7.26411 6.40104 7.06124 6.31881 6.86119 6.29247C6.42294 6.23478 5.97972 6.35354 5.62904 6.62263C5.36603 6.82444 5.17188 7.16071 4.7836 7.83324C4.39532 8.50576 4.20117 8.84203 4.1579 9.17071C4.10021 9.60896 4.21896 10.0522 4.48805 10.4029C4.61088 10.5629 4.78349 10.6975 5.0514 10.8658C5.44524 11.1133 5.69865 11.5348 5.69862 12C5.6986 12.4651 5.4452 12.8866 5.05139 13.134C4.78345 13.3024 4.61081 13.4369 4.48797 13.597C4.21888 13.9477 4.10012 14.3909 4.15782 14.8291C4.20109 15.1578 4.39523 15.4941 4.78352 16.1666C5.1718 16.8392 5.36595 17.1754 5.62896 17.3772C5.97964 17.6463 6.42286 17.7651 6.8611 17.7074C7.06115 17.6811 7.26401 17.5988 7.54377 17.451C7.95497 17.2336 8.44671 17.2249 8.84949 17.4575C9.25227 17.69 9.49062 18.1202 9.508 18.585C9.51983 18.9012 9.55005 19.118 9.62726 19.3044C9.79642 19.7128 10.1209 20.0373 10.5293 20.2064C10.8355 20.3333 11.2238 20.3333 12.0004 20.3333C12.777 20.3333 13.1653 20.3333 13.4715 20.2064C13.8799 20.0373 14.2044 19.7128 14.3735 19.3044C14.4508 19.118 14.481 18.9012 14.4928 18.5849C14.5102 18.1202 14.7485 17.69 15.1512 17.4575C15.554 17.2249 16.0458 17.2336 16.457 17.4509C16.7367 17.5988 16.9396 17.681 17.1396 17.7073C17.5779 17.765 18.0211 17.6463 18.3718 17.3772C18.6348 17.1754 18.8289 16.8391 19.2172 16.1666C19.6055 15.494 19.7996 15.1578 19.8429 14.8291C19.9006 14.3908 19.7818 13.9476 19.5127 13.5969C19.3899 13.4369 19.2173 13.3023 18.9494 13.134C18.5555 12.8865 18.3021 12.465 18.3022 11.9999C18.3022 11.5348 18.5556 11.1134 18.9494 10.866C19.2173 10.6976 19.39 10.563 19.5128 10.4029C19.7819 10.0522 19.9007 9.60902 19.843 9.17077C19.7997 8.84209 19.6056 8.50582 19.2173 7.83329C18.829 7.16076 18.6348 6.8245 18.3718 6.62268C18.0212 6.35359 17.5779 6.23483 17.1397 6.29253C16.9396 6.31887 16.7368 6.40109 16.457 6.54896C16.0458 6.76629 15.5541 6.77497 15.1513 6.54243C14.7485 6.30988 14.5102 5.87968 14.4928 5.41491C14.481 5.09869 14.4507 4.8819 14.3735 4.69549C14.2044 4.28711 13.8799 3.96265 13.4715 3.79349Z"
                                  stroke-width="1.3"
                                />
                              </svg>
                              <svg
                                class="company-card-icon-btn__icon company-card-icon-btn__icon--hover company-card-settings-icon--bold"
                                width="20"
                                height="20"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M9.51921 1.43481C9.27231 1.33331 8.95932 1.33331 8.33333 1.33331C7.70735 1.33331 7.39435 1.33331 7.14746 1.43481C6.81827 1.57013 6.55673 1.8297 6.42037 2.1564C6.35813 2.30554 6.33377 2.47898 6.32423 2.73197C6.31023 3.10377 6.1181 3.44791 5.79344 3.63393C5.46879 3.81996 5.07243 3.81301 4.74099 3.63915C4.51545 3.52085 4.35192 3.45506 4.19066 3.43399C3.83739 3.38783 3.48012 3.48284 3.19744 3.69811C2.98542 3.85957 2.82893 4.12858 2.51594 4.6666C2.20294 5.20462 2.04645 5.47364 2.01156 5.73658C1.96506 6.08718 2.06079 6.44175 2.2777 6.7223C2.3767 6.85035 2.51585 6.958 2.7318 7.09266C3.04928 7.29064 3.25355 7.62788 3.25353 7.99999C3.25351 8.37206 3.04924 8.70926 2.7318 8.90721C2.51581 9.0419 2.37665 9.14955 2.27763 9.27761C2.06072 9.55816 1.96499 9.91273 2.0115 10.2633C2.04638 10.5263 2.20288 10.7953 2.51587 11.3333C2.82886 11.8713 2.98536 12.1403 3.19737 12.3018C3.48005 12.5171 3.83733 12.6121 4.19059 12.5659C4.35185 12.5449 4.51537 12.4791 4.74089 12.3608C5.07235 12.1869 5.46873 12.18 5.79341 12.366C6.11809 12.552 6.31022 12.8962 6.32424 13.268C6.33377 13.521 6.35813 13.6944 6.42037 13.8436C6.55673 14.1703 6.81827 14.4298 7.14746 14.5652C7.39435 14.6666 7.70735 14.6666 8.33333 14.6666C8.95932 14.6666 9.27231 14.6666 9.51921 14.5652C9.8484 14.4298 10.1099 14.1703 10.2463 13.8436C10.3085 13.6944 10.3329 13.521 10.3424 13.268C10.3564 12.8962 10.5485 12.552 10.8732 12.366C11.1979 12.1799 11.5943 12.1869 11.9257 12.3607C12.1512 12.479 12.3148 12.5448 12.476 12.5659C12.8293 12.612 13.1865 12.517 13.4692 12.3018C13.6812 12.1403 13.8377 11.8713 14.1507 11.3333C14.4637 10.7952 14.6202 10.5262 14.6551 10.2633C14.7016 9.91269 14.6059 9.55812 14.389 9.27757C14.29 9.14951 14.1508 9.04186 13.9348 8.90718C13.6174 8.70923 13.4131 8.372 13.4131 7.99992C13.4132 7.62788 13.6174 7.2907 13.9348 7.09277C14.1508 6.95808 14.29 6.85042 14.389 6.72234C14.6059 6.4418 14.7017 6.08723 14.6552 5.73663C14.6203 5.47368 14.4638 5.20467 14.1508 4.66665C13.8378 4.12862 13.6813 3.85961 13.4693 3.69816C13.1866 3.48289 12.8293 3.38788 12.4761 3.43404C12.3148 3.45511 12.1513 3.52088 11.9258 3.63918C11.5943 3.81304 11.1979 3.81999 10.8733 3.63395C10.5486 3.44792 10.3564 3.10375 10.3424 2.73194C10.3329 2.47896 10.3085 2.30553 10.2463 2.1564C10.1099 1.8297 9.8484 1.57013 9.51921 1.43481ZM8.33333 9.99998C9.44631 9.99998 10.3486 9.10455 10.3486 7.99998C10.3486 6.89541 9.44631 5.99998 8.33333 5.99998C7.22035 5.99998 6.3181 6.89541 6.3181 7.99998C6.3181 9.10455 7.22035 9.99998 8.33333 9.99998Z"
                                />
                              </svg>
                            </button>
                            <div class="company-card-menu-wrap">
                              <button
                                type="button"
                                class="company-card-icon-btn company-card-icon-btn--menu company-card-icon-btn--swap"
                                (click)="toggleCompanyMenu(element, $event)"
                                [attr.aria-expanded]="isCompanyMenuOpen(element)"
                                aria-haspopup="menu"
                                aria-label="More actions"
                              >
                                <svg
                                  class="company-card-icon-btn__icon company-card-icon-btn__icon--default company-card-menu-icon company-card-menu-icon--linear"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  aria-hidden="true"
                                >
                                  <circle cx="3.75" cy="9" r="0.85" />
                                  <circle cx="9" cy="9" r="0.85" />
                                  <circle cx="14.25" cy="9" r="0.85" />
                                </svg>
                                <svg
                                  class="company-card-icon-btn__icon company-card-icon-btn__icon--hover company-card-menu-icon company-card-menu-icon--bold"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  aria-hidden="true"
                                >
                                  <circle cx="3.75" cy="9" r="1.5" />
                                  <circle cx="9" cy="9" r="1.5" />
                                  <circle cx="14.25" cy="9" r="1.5" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </article>
                    }
                  </div>
                </div>
              } @else {
                <div class="company-list-cards-sheet company-list-cards-sheet--empty">
                  <p class="company-list-empty">No data matching the filter.</p>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (companyMenuCompany) {
  <div
    class="figma-table-col-menu-panel"
    role="menu"
    [style.top.px]="companyMenuTop"
    [style.left.px]="companyMenuLeft"
    (click)="$event.stopPropagation()"
  >
    <button
      type="button"
      class="figma-table-col-menu-item"
      role="menuitem"
      (click)="onCompanyMenuChangeFy(companyMenuCompany)"
    >
      <svg
        class="figma-table-col-menu-icon"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect x="3" y="4" width="12" height="11" rx="1.5" stroke="currentColor" stroke-width="1.3" />
        <path d="M3 7.5H15" stroke="currentColor" stroke-width="1.3" />
        <path d="M6.25 2.75V5.25" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
        <path d="M11.75 2.75V5.25" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      </svg>
      <span>Change FY</span>
    </button>
    <button
      type="button"
      class="figma-table-col-menu-item figma-table-col-menu-item--danger"
      role="menuitem"
      (click)="openDeleteCompanyModal(companyMenuCompany)"
    >
      <svg
        class="figma-table-col-menu-icon"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path d="M4.5 5.5h9" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
        <path
          d="M6.25 5.5V4.25a1.25 1.25 0 0 1 1.25-1.25h3a1.25 1.25 0 0 1 1.25 1.25V5.5"
          stroke="currentColor"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.25 5.5v8.5a1.25 1.25 0 0 0 1.25 1.25h3.5a1.25 1.25 0 0 0 1.25-1.25V5.5"
          stroke="currentColor"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span>Delete Company</span>
    </button>
  </div>
}


<!--Delete Company Modal -->
<div class="modal delete-company-modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Delete Company</h2>
        <button type="button" class="btn-close" (click)="closepopup()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="deleteForm" class="delete-company-modal__form">
          <div class="delete-company-modal__options">
            <label class="delete-company-modal__option" for="inlineRadio1">
              <input
                class="delete-company-modal__radio"
                type="radio"
                name="deleteCompanyFY"
                id="inlineRadio1"
                value="company"
                formControlName="deleteCompanyFY"
                (change)="onChangeDeleteOption()"
              />
              <span>Delete Company</span>
            </label>
            <label class="delete-company-modal__option" for="inlineRadio2">
              <input
                class="delete-company-modal__radio"
                type="radio"
                name="deleteCompanyFY"
                id="inlineRadio2"
                value="financialYear"
                formControlName="deleteCompanyFY"
                (change)="onChangeDeleteOption()"
              />
              <span>Delete Financial Year</span>
            </label>
          </div>
          @if (showFinancialYear) {
            <div class="delete-company-modal__fy">
              <label class="delete-company-modal__fy-label" for="delete-company-fy">Financial Year</label>
              <p-select
                inputId="delete-company-fy"
                class="w-100"
                styleClass="delete-company-modal__select"
                tabindex="2"
                formControlName="financialYear"
                [options]="financialyears"
                optionLabel="viewValue"
                optionValue="value"
                placeholder="Select Financial Year..."
                [showClear]="true"
                appendTo="body"
              />
            </div>
          }
        </form>
      </div>
      <div class="modal-footer">
        <p-button label="Delete" severity="danger" (onClick)="deleteCompany()" styleClass="delete-company-modal__btn delete-company-modal__btn--danger" />
        <p-button label="Close" (onClick)="closepopup()" [outlined]="true" styleClass="delete-company-modal__btn delete-company-modal__btn--secondary" />
      </div>
    </div>
  </div>
</div>

    <div class="modal enter-company-modal" tabindex="-1" [ngStyle]="{ display: displayEnterModal }">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">Enter {{ selectedCompany?.name }}</h2>
            <button type="button" class="btn-close" aria-label="Close" (click)="closeEnterCompanyModal()"></button>
          </div>
          <div class="modal-body">
            <label class="enter-company-modal__label" for="enter-company-fy">Financial Year</label>
            <p-select
              inputId="enter-company-fy"
              [options]="enterFinancialYears"
              optionLabel="viewValue"
              optionValue="value"
              [(ngModel)]="enterFinancialYear"
              placeholder="Select financial year"
              styleClass="enter-company-modal__select w-100"
              appendTo="body"
              [filter]="false"
              [loading]="isLoadingEnterFinancialYears"
              [disabled]="isLoadingEnterFinancialYears || !enterFinancialYears.length"
            />
          </div>
          <div class="modal-footer">
            <p-button
              label="Enter"
              (onClick)="confirmEnterCompany()"
              [loading]="isEnteringCompany"
              [disabled]="!enterFinancialYear"
              styleClass="enter-company-modal__btn enter-company-modal__btn--primary"
            />
            <p-button
              label="Cancel"
              (onClick)="closeEnterCompanyModal()"
              [outlined]="true"
              styleClass="enter-company-modal__btn enter-company-modal__btn--secondary"
            />
          </div>
        </div>
      </div>
    </div>


    <div class="modal subscription-details-modal" tabindex="-1" role="dialog" data-form-focus-nav [ngStyle]="{ display: displaySubscriptionModal}">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">Complete Subscription Details</h2>
            @if (showModalClose) {
              <button type="button" class="btn-close" aria-label="Close" (click)="closeSubscriptionDetailsModal()"></button>
            }
          </div>
          <div class="modal-body">
            <div class="row ms-sm-1 p-3 pt-0" [formGroup]="subscriptionDetailsFormGroup">
              <div class="col-12">
                <label class="col-8 col-form-label">Mobile Number</label>
                <div class="col-12">
                  <div class="subscription-details-modal__mobile-row">
                    <input
                      type="text"
                      formControlName="MobileNumber"
                      class="rounded border border-1 subscription-details-modal__mobile-input"
                      autocomplete="tel"
                      data-initial-focus
                      (input)="onMobileNumberInput()"
                    />
                    @if (isMobileNumberChanged) {
                      <button
                        type="button"
                        class="subscription-details-modal__otp-btn"
                        [disabled]="!canSendOtp || isSendingOTP"
                        (click)="sendOTP()"
                      >
                        {{ isSendingOTP ? 'Sending…' : (isOTPSent ? 'Resend OTP' : 'Send OTP') }}
                      </button>
                    }
                  </div>
                  @if (isMobileNumberChanged && isOTPSent) {
                    <div class="success-message">
                      OTP sent!
                    </div>
                  }
                </div>
              </div>
              @if (isMobileNumberChanged) {
                <div class="col-12">
                  <label class="col-8 col-form-label">OTP</label>
                  <div class="col-12">
                    <input type="number" formControlName="OTP" class="rounded border border-1 col-12" />
                    @if (isOTPValid === false) {
                      <div class="error-message">
                        Invalid OTP!
                      </div>
                    }
                  </div>
                </div>
              }
              <div class="col-12">
                <label class="col-8 col-form-label">Address</label>
                <div class="col-12">
                  <input type="text" formControlName="Address" class="rounded border border-1 col-12" />
                </div>
              </div>
              <div class="col-12">
                <label class="col-8 col-form-label">State</label>
                <div class="col-12">
                  <input type="text" formControlName="State" class="rounded border border-1 col-12"/>
                </div>
              </div>
              <div class="col-12">
                <label class="col-8 col-form-label">City</label>
                <div class="col-12">
                  <input type="text" formControlName="City" class="rounded border border-1 col-12" />
                </div>
              </div>
              <div class="col-12">
                <label class="col-8 col-form-label">Pin code</label>
                <div class="col-12">
                  <input type="text" formControlName="Pincode" class="rounded border border-1 col-12" />
                </div>
              </div>
              <div class="col-12">
                <label class="col-8 col-form-label">GST Number</label>
                <div class="col-12">
                  <input type="text" formControlName="GstNo" class="rounded border border-1 col-12" />
                </div>
              </div>
                <div class="col-12">
                  <label class="col-8 col-form-label">Business Type</label>
                  <div class="col-12">
                    <p-select formControlName="BusinessType" [options]="businessTypeOptions"
                      optionLabel="label" optionValue="value" placeholder="Select business type"
                      styleClass="w-100 subscription-details-modal__select" appendTo="body" />
                  </div>
                </div>
              <div class="col-12">
                <label class="col-8 col-form-label">Password</label>
                <div class="col-12">
                  <div class="subscription-details-modal__input-wrap">
                    <input
                      [type]="hide ? 'password' : 'text'"
                      formControlName="Password"
                      class="subscription-details-modal__password-input"
                      autocomplete="new-password"
                    />
                    <button
                      type="button"
                      class="subscription-details-modal__input-toggle"
                      (click)="hide = !hide"
                      [attr.aria-label]="hide ? 'Show password' : 'Hide password'"
                      [attr.aria-pressed]="!hide"
                    >
                      <i class="fas" [class.fa-eye]="hide" [class.fa-eye-slash]="!hide" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <label class="col-8 col-form-label">Confirm Password</label>
                <div class="col-12">
                  <div class="subscription-details-modal__input-wrap">
                    <input
                      [type]="hide ? 'password' : 'text'"
                      formControlName="ConfirmPassword"
                      class="subscription-details-modal__password-input"
                      autocomplete="new-password"
                    />
                    <button
                      type="button"
                      class="subscription-details-modal__input-toggle"
                      (click)="hide = !hide"
                      [attr.aria-label]="hide ? 'Show password' : 'Hide password'"
                      [attr.aria-pressed]="!hide"
                    >
                      <i class="fas" [class.fa-eye]="hide" [class.fa-eye-slash]="!hide" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            @if (isErrorMessage) {
              <span style="color: red;">**Please fill all the fields.</span>
            }
            @if (isPasswordMatchError) {
              <span style="color: red;">**Password & Confirm Password doesn't match!</span>
            }
          </div>
          <div class="modal-footer">
            <div class="buttons-container">
              <button type="button" class="primary-button" (click)="UpdateSubscriberDetails()">Save changes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
